/** @flow */

import React from "react";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const WarningTriangleIcon = (props: Props) => (
  <svg
    width="23px"
    height="21px"
    viewBox="0 0 23 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    onClick={props.onClick}
    className={props.className}
  >
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon id="Triangle" stroke="#F5A623" fill="#F5A623" points="11.5 0 22 20 1 20" />
      <text
        id="!"
        fontFamily="Impact"
        fontSize="12"
        fontStyle="condensed"
        fontWeight="700"
        fill="#FFFFFF"
      >
        <tspan x="10" y="18">
          !
        </tspan>
      </text>
    </g>
  </svg>
);

export default WarningTriangleIcon;
